export const siteSettings = {
  name: "Prestige Capital Wins",
  link: "https://prestigecapitalwins.com",
  email: "support@prestigecapitalwins.com",
  appLink: "https://app.prestigecapitalwins.com",
};
